(() => {
  const toggleVideoPlayback = (container, video) => {
    if (
      !container.querySelector('.banner-grid__grid').closest('.banner-grid__swiper')?.swiper ||
      video.closest('.swiper-slide-visible')
    ) {
      video.currentTime = 0;
      video.play();
    } else {
      video.pause();
    }
  };

  const initBannerGrid = (section) => {
    if (!section) return;
    const swiperEl = section.querySelector('.banner-grid__swiper');
    if (!swiperEl) return;

    const grid = section.querySelector('.banner-grid__grid');
    const cards = section.querySelectorAll('.banner-grid__card');
    const slidesCount = grid.getAttribute('data-slides');

    let swiperInstance = null;

    cards.forEach((card) => {
      const video = card.querySelector('video');
      if (!video) return;

      const mutationObserver = new MutationObserver(() => {
        if (video.hasAttribute('controls')) {
          video.removeAttribute('controls');
          video.controls = false;
        }
      });

      mutationObserver.observe(video, {
        attributes: true,
        attributeFilter: ['controls'],
      });
    });

    const setupSwiper = (width) => {
      if (width < 990) {
        grid.classList.add('swiper-wrapper');
        cards.forEach((card) => card.classList.add('swiper-slide'));

        if (swiperInstance) swiperInstance.destroy(true, true);

        swiperInstance = new Swiper(swiperEl, {
          slidesPerView: slidesCount,
          spaceBetween: 8,
          mousewheel: { forceToAxis: true },
          watchSlidesProgress: true,
          pagination: { el: swiperEl.querySelector('.swiper-pagination'), type: 'bullets' },
          on: {
            slideChange() {
              this.slides.forEach((slide) => {
                const video = slide.querySelector('.banner-grid__card video');
                if (video) toggleVideoPlayback(section, video);
              });
            },
          },
        });
        swiperInstance.pagination.update();
      } else {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
        grid.classList.remove('swiper-wrapper');
        cards.forEach((card) => {
          card.classList.remove('swiper-slide');
          card.removeAttribute('style');
        });
      }
    };

    new ResizeObserver((entries) => {
      const width = entries[0].contentRect.width;
      setupSwiper(width);
    }).observe(section);

    const intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          toggleVideoPlayback(section, entry.target);
        } else {
          entry.target.pause();
        }
      });
    });

    section.querySelectorAll('.banner-grid__card video').forEach((video) => {
      intersectionObserver.observe(video);
    });
  };

  initBannerGrid(document.currentScript.parentElement);
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('banner-grid-section')) initBannerGrid(e.target);
  });
})();
